import FirebaseHandlerBase from "../firebase_handler_base";
import {SYSTEM_EVENTS} from "../../../../events/events";
import Event from "../../../../utils/event";
import {ISubscriptionParams} from "../firebase_const";

interface BankrollData {
  casinoRM: number;
  cid: number;
  currency: string;
  dateUpdated: {};
  pokerRM: number;
  realBR: number;
  sportRM: number;
  updateCounter: number;
  IsCasinoBankrollRestricted?: boolean | string | number;
}

export default class BankrollHandler extends FirebaseHandlerBase{
  static CLASS = 'BankrollHandler';

  protected getSubscriptionParams(): ISubscriptionParams {
    return {
      eventName: 'bankroll',
      successCallback: this._updateBankroll,
      params: {currency: this.serviceFactory.currencyService().getCurrency()}
    };
  }

  protected getFeatureName(): string {
    return "BR";
  }

  protected getFeatureLabel(): string {
    return "Bankroll";
  }


  protected getFallbackServiceName(): string{
    return "Wallet";
  }

  private _updateBankroll = (data: BankrollData) => {
      this.logger.debug('Firebase got BR message. Raw data: ' + JSON.stringify(data));

      const balanceData = {
        Balance: this._getBalance(data),
        Currency: data.currency,
        RealMoneyBankroll: data.realBR,
      };

      Event.fire(SYSTEM_EVENTS.SESSION_EVENT_WALLET, balanceData);

      this.logger.debug('FIREBASE got BR message. Parsed data:  ' + JSON.stringify(balanceData));

      // filter elastic bankroll updates only for vip users, avoiding too much reporting
      const accountData = this.serviceFactory.userService().getAccountData();
      if (accountData && accountData.IsVip) {
        this.serviceFactory.firebaseElasticService().sendMessageUpdate(this.getFeatureLabel(), JSON.stringify(data));
      }
   
  };

    private _getBalance(data: BankrollData): number{
      const bonus = data.casinoRM || 0;
      const isRestricted: boolean = data.IsCasinoBankrollRestricted === "true" ||
                                    data.IsCasinoBankrollRestricted === true ||
                                    data.IsCasinoBankrollRestricted === "1" ||
                                    data.IsCasinoBankrollRestricted === 1;
      return (isRestricted) ? 0 : (data.realBR + bonus);
    }
}
